import { ScrollTrigger } from "gsap/ScrollTrigger";
const windowWidth = window.innerWidth;
let windowOrientation = screen.orientation ? screen.orientation.type : 'undefined';

const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return "Android"
  } else if (/iPad|iPhone/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ) {
    return "iOS"
  }
  return "Other"
}

export const updateScrollTriger = () => {
  if (windowOrientation !== screen.orientation.type) {
    ScrollTrigger.refresh();
    windowOrientation = screen.orientation.type;
  }

  if(getMobileOS() === "Other") {
    setTimeout(() => ScrollTrigger.refresh(), 300);
  } else {
    windowWidth != window.innerWidth && setTimeout(() => ScrollTrigger.refresh(), 300);
  }
}

